/* eslint-disable unicorn/prefer-module */
/* eslint-disable no-console */
import { useState, useEffect, useMemo } from "react";
import { toast } from "react-hot-toast";
import { IoLocation } from "react-icons/io5";
import { GENERAL } from "../../constants";
import { EDITORES_PIN } from "../../constants/permisos";
import { useAuthContext } from "../../context/auth";
import { getEdificios, updateEdificio } from "../../utils";
import { getLocale } from "../../utils/getLocale";
import { APIProvider, Map, AdvancedMarker } from "@vis.gl/react-google-maps";
import "./stylesMapa.scss";

export const Mapa = () => {
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [edificios, setEdificios] = useState(null);
  const [selectedCategories, setSelectedCategories] = useState(["OPERATIVO", "INSTALACIÓN", "PRÓXIMO", "STANDBY"]);
  const [buildingCounts, setBuildingCounts] = useState({});
  // Editor de pin (gateado a EDITORES_PIN): edificio en edición + coord provisoria (solo estado local en Fase 2)
  const [editandoPinId, setEditandoPinId] = useState(null);
  const [coordEditada, setCoordEditada] = useState(null);
  // Tipo de mapa: "roadmap" (minimalista, estilizado por el mapId), "satellite", "hybrid"
  const [mapTypeId, setMapTypeId] = useState("roadmap");

  const { pais, id } = useAuthContext();

  const puedeEditarPin = EDITORES_PIN.includes(id);
  const esSatelital = mapTypeId === "satellite" || mapTypeId === "hybrid";

  const imageContext = require.context("../../img/edificios/", false, /\.(png|jpeg)$/);

  const logo = useMemo(
    () =>
      ({
        Chile: require("../../img/wecast-logo.png"),
        Perú: require("../../img/visiona-logo.png"),
        Uruguay: require("../../img/screenmedia-logo.png"),
      })[pais] || require("../../img/visiona-logo.png"),
    [pais]
  );

  const position = useMemo(
    () =>
      ({
        Chile: { lat: -33.41305, lng: -70.60635 },
        Perú: { lat: -12.10979, lng: -77.01751 },
        Uruguay: { lat: -34.89434, lng: -56.15867 },
      })[pais] || { lat: -12.10979, lng: -77.01751 },
    [pais]
  );

  const handleCategoryToggle = (category) => {
    const updatedCategories = [...selectedCategories];
    const index = updatedCategories.indexOf(category);

    if (index !== -1) {
      updatedCategories.splice(index, 1);
    } else {
      updatedCategories.push(category);
    }

    setSelectedCategories(updatedCategories);
  };

  const CustomInfoBox = ({ title, ascensores, totems, personas, espera, id, estado }) => {
    const getImageSrc = (id) => {
      try {
        return imageContext(`./${id}.png`);
      } catch {
        try {
          return imageContext(`./${id}.jpeg`);
        } catch {
          return require("../../img/edificios/49.jpeg"); // Ensure default.jpeg exists
        }
      }
    };
    const aforoFormat = { minimumFractionDigits: 0, maximumFractionDigits: 0 };
    const aforoTexto = personas == null ? "N/D" : personas.toLocaleString(getLocale(pais), aforoFormat);
    return (
      <div
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          backgroundColor: "whitesmoke",
          padding: 10,
          borderRadius: 5,
          width: "350px",
          border: "1px solid black",
          textAlign: "left",
        }}
      >
        <h2
          style={{
            background: "darkred",
            padding: "8px",
            margin: 0,
            borderRadius: "3px",
            color: "white",
            marginBottom: "15px",
            textAlign: "center",
          }}
        >
          {title}
        </h2>
        <p>AFORO: {aforoTexto}</p>
        <p>INVENTARIO:</p>
        <ul>
          {ascensores ? <li>ASCENSORES: {ascensores}</li> : null}
          {totems ? <li>TOTEMS: {totems}</li> : null}
          {espera ? <li>ESPERA: {espera}</li> : null}
        </ul>
        {(estado === "OPERATIVO" || estado === "INSTALACIÓN") && (
          <img
            src={getImageSrc(id)}
            alt="Edificio"
            style={{
              width: "100%",
              height: "auto",
              marginBottom: "10px",
              borderRadius: "15px",
            }}
          />
        )}
        {puedeEditarPin && !(editandoPinId === id && coordEditada) && (
          <button
            type="button"
            onClick={() => {
              if (editandoPinId === id) {
                setEditandoPinId(null);
                setCoordEditada(null);
              } else {
                setEditandoPinId(id);
                setCoordEditada(null);
              }
            }}
            style={{
              width: "100%",
              padding: "8px",
              borderRadius: "5px",
              border: "1px solid black",
              cursor: "pointer",
              fontWeight: "bold",
              color: "white",
              background: editandoPinId === id ? "#4A148C" : "darkred",
            }}
          >
            {editandoPinId === id ? "SALIR DE EDICIÓN" : "EDITAR UBICACIÓN"}
          </button>
        )}
        {puedeEditarPin && editandoPinId === id && coordEditada && (
          <div style={{ marginTop: 10 }}>
            <p style={{ margin: "0 0 8px", fontWeight: "bold" }}>
              Nueva ubicación: {coordEditada.lat.toFixed(5)} / {coordEditada.lng.toFixed(5)}
            </p>
            <div style={{ display: "flex", gap: 8 }}>
              <button
                type="button"
                onClick={guardarUbicacion}
                style={{
                  flex: 1,
                  padding: "8px",
                  borderRadius: "5px",
                  border: "1px solid black",
                  cursor: "pointer",
                  fontWeight: "bold",
                  color: "white",
                  background: "#4A148C",
                }}
              >
                GUARDAR
              </button>
              <button
                type="button"
                onClick={cancelarUbicacion}
                style={{
                  flex: 1,
                  padding: "8px",
                  borderRadius: "5px",
                  border: "1px solid black",
                  cursor: "pointer",
                  fontWeight: "bold",
                  color: "white",
                  background: "grey",
                }}
              >
                CANCELAR
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  const getMarkerColor = (estado) => {
    switch (estado) {
      case "STANDBY":
        return "grey";
      case "PRÓXIMO":
        return "blue";
      case "OPERATIVO":
        return "darkred";
      default:
        return "green";
    }
  };

  // Color de pin/leyenda según tipo de mapa. En satélite/híbrido los rojos y
  // verdes actuales se pierden contra el fondo (verde sobre parques, rojo
  // apagado): operativos→azul, instalación→magenta (alta visibilidad, casi
  // inexistentes en imágenes satelitales). En roadmap se mantienen los
  // colores de hoy (getMarkerColor). PRÓXIMO/STANDBY quedan como están.
  const getPinColor = (estado, tipo) => {
    const esSatelital = tipo === "satellite" || tipo === "hybrid";
    if (esSatelital && estado === "OPERATIVO") return "#448AFF";
    if (esSatelital && estado === "INSTALACIÓN") return "#F50057";
    return getMarkerColor(estado);
  };

  const Legend = () => (
    <div
      style={{
        position: "absolute",
        top: "10px",
        left: "10px",
        backgroundColor: esSatelital ? "#212529" : "white",
        padding: 10,
        borderRadius: 5,
        border: "1px solid black",
        textAlign: "left",
        zIndex: 3,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <label
        style={{
          display: "flex",
          alignItems: "center",
          color: selectedCategories.includes("OPERATIVO")
            ? getPinColor("OPERATIVO", mapTypeId)
            : esSatelital
              ? "white"
              : "black",
          marginBottom: 5,
          cursor: "pointer",
          fontSize: "20px",
        }}
      >
        <input
          type="checkbox"
          checked={selectedCategories.includes("OPERATIVO")}
          onChange={() => handleCategoryToggle("OPERATIVO")}
          style={{ marginRight: "10px" }}
        />
        OPERATIVOS: {buildingCounts["OPERATIVO"] || 0} edificios
      </label>
      {buildingCounts["INSTALACIÓN"] !== 0 && (
        <label
          style={{
            display: "flex",
            alignItems: "center",
            color: selectedCategories.includes("INSTALACIÓN")
              ? getPinColor("INSTALACIÓN", mapTypeId)
              : esSatelital
                ? "white"
                : "black",
            marginBottom: 5,
            cursor: "pointer",
            fontSize: "20px",
          }}
        >
          <input
            type="checkbox"
            checked={selectedCategories.includes("INSTALACIÓN")}
            onChange={() => handleCategoryToggle("INSTALACIÓN")}
            style={{ marginRight: "10px" }}
          />
          INSTALACIÓN: {buildingCounts["INSTALACIÓN"] || 0} edificios
        </label>
      )}
      {buildingCounts["PRÓXIMO"] !== 0 && (
        <label
          style={{
            display: "flex",
            alignItems: "center",
            color: selectedCategories.includes("PRÓXIMO")
              ? getPinColor("PRÓXIMO", mapTypeId)
              : esSatelital
                ? "white"
                : "black",
            marginBottom: 5,
            cursor: "pointer",
            fontSize: "20px",
          }}
        >
          <input
            type="checkbox"
            checked={selectedCategories.includes("PRÓXIMO")}
            onChange={() => handleCategoryToggle("PRÓXIMO")}
            style={{ marginRight: "10px" }}
          />
          PRÓXIMO: {buildingCounts["PRÓXIMO"] || 0} edificios
        </label>
      )}
    </div>
  );

  // Selector de tipo de mapa (no gateado: es navegación, lo ve cualquiera).
  // Permanece visible y funcional también durante el modo edición de pin —
  // cambiar de tipo no interrumpe el drag ni la confirmación pendiente, y
  // permite calzar el pin contra la imagen satelital del edificio real.
  const MAP_TYPES = [
    { id: "roadmap", label: "ESTÁNDAR" },
    { id: "satellite", label: "SATÉLITE" },
    { id: "hybrid", label: "HÍBRIDO" },
  ];

  const MapTypeSelector = () => (
    <div
      style={{
        position: "absolute",
        bottom: "32px",
        left: "10px",
        backgroundColor: "white",
        padding: 6,
        borderRadius: 5,
        border: "1px solid black",
        zIndex: 3,
        display: "flex",
        gap: 6,
      }}
    >
      {MAP_TYPES.map((tipo) => (
        <button
          key={tipo.id}
          type="button"
          onClick={() => setMapTypeId(tipo.id)}
          style={{
            flex: 1,
            textAlign: "center",
            padding: "6px 10px",
            borderRadius: 5,
            border: "1px solid black",
            cursor: "pointer",
            fontWeight: "bold",
            color: mapTypeId === tipo.id ? "white" : "black",
            background: mapTypeId === tipo.id ? "darkred" : "white",
          }}
        >
          {tipo.label}
        </button>
      ))}
    </div>
  );

  const sortEdificios = (a, b) => {
    const order = {
      grey: 1,
      blue: 2,
      red: 3,
    };

    return order[getMarkerColor(a.estado)] - order[getMarkerColor(b.estado)];
  };

  const filteredEdificios = edificios
    ? edificios.filter((edificio) => selectedCategories.includes(edificio.estado))
    : [];

  const handleMarkerClick = (marker) => setSelectedMarker(marker);

  // Cancelar edición: descartar la coord provisoria y salir del modo (no se tocó la fuente).
  const cancelarUbicacion = () => {
    setCoordEditada(null);
    setEditandoPinId(null);
  };

  // Guardar: PATCH no-destructivo pasando el objeto edificio ENTERO (regla 10.54), no solo {id,lat,lng}.
  const guardarUbicacion = async () => {
    if (!selectedMarker || !coordEditada) return;
    try {
      await updateEdificio({ ...selectedMarker, lat: coordEditada.lat, lng: coordEditada.lng });
      const coordNueva = { lat: coordEditada.lat, lng: coordEditada.lng };
      // Reflejar en estado local para que el pin quede en su nueva posición sin recargar.
      setEdificios((prev) =>
        prev ? prev.map((e) => (e.id === selectedMarker.id ? { ...e, ...coordNueva } : e)) : prev
      );
      setSelectedMarker((prev) => (prev ? { ...prev, ...coordNueva } : prev));
      setCoordEditada(null);
      setEditandoPinId(null);
      toast.success("Ubicación actualizada");
    } catch {
      // No limpiar estado: que el usuario pueda reintentar.
      toast.error("Error al guardar la ubicación");
    }
  };

  useEffect(() => {
    const initialize = async () => {
      const newEdificios = await getEdificios({ pais });
      setEdificios(newEdificios);
    };

    initialize();
  }, [pais]);

  useEffect(() => {
    const filteredEdificios = edificios
      ? edificios.filter((edificio) => selectedCategories.includes(edificio.estado))
      : [];

    const counts = selectedCategories.reduce((acc, category) => {
      acc[category] = filteredEdificios.filter((edificio) => edificio.estado === category).length;
      return acc;
    }, {});
    setBuildingCounts(counts);
  }, [selectedCategories, edificios]);

  return (
    <APIProvider apiKey={GENERAL.GMAP_API_KEY}>
      <div className="Mapa">
        <Map defaultCenter={position} defaultZoom={13.5} mapId={GENERAL.GMAP_MAP_ID} mapTypeId={mapTypeId}>
          {filteredEdificios &&
            filteredEdificios.sort(sortEdificios).map((edificio) => {
              const markerColor = getMarkerColor(edificio.estado);
              const zIndex = markerColor === "grey" ? 2 : markerColor === "blue" ? 1 : 0;

              const editandoEste = puedeEditarPin && editandoPinId === edificio.id;
              const markerPosition =
                editandoEste && coordEditada ? coordEditada : { lat: edificio.lat, lng: edificio.lng };
              // Pin de edición: violeta en Estándar; blanco en satélite/híbrido (con el halo nunca se hunde).
              const pinColor = editandoEste
                ? esSatelital
                  ? "#FFFFFF"
                  : "#4A148C"
                : getPinColor(edificio.estado, mapTypeId);
              // En satélite el anillo hueco del pin deja ver el fondo oscuro: lo tapamos con un
              // círculo del color del pin por detrás (no aplica al pin de edición).
              const taparHueco = esSatelital && !editandoEste;

              return (
                <AdvancedMarker
                  key={edificio.id}
                  position={markerPosition}
                  draggable={editandoEste}
                  onClick={() => handleMarkerClick(edificio)}
                  onDragEnd={
                    editandoEste
                      ? (e) => {
                          const newLat = e.latLng?.lat();
                          const newLng = e.latLng?.lng();
                          if (newLat != null && newLng != null) {
                            setCoordEditada({ lat: newLat, lng: newLng });
                          }
                        }
                      : undefined
                  }
                >
                  <span
                    style={{
                      position: "relative",
                      display: "inline-flex",
                      lineHeight: 0,
                      fontSize: editandoEste ? "52px" : "30px",
                    }}
                  >
                    {taparHueco && (
                      <span
                        style={{
                          position: "absolute",
                          left: "50%",
                          top: "37.5%",
                          width: "0.28em",
                          height: "0.28em",
                          transform: "translate(-50%, -50%)",
                          borderRadius: "50%",
                          background: pinColor,
                        }}
                      />
                    )}
                    <IoLocation
                      style={{
                        position: "relative",
                        color: pinColor,
                        fontSize: "1em",
                        zIndex: editandoEste ? 4 : zIndex,
                        filter: esSatelital ? "drop-shadow(0 0 1px white) drop-shadow(0 0 1px white)" : undefined,
                      }}
                    />
                  </span>
                </AdvancedMarker>
              );
            })}
        </Map>
        {selectedMarker && (
          <CustomInfoBox
            ascensores={selectedMarker.pantallas}
            totems={selectedMarker.totems}
            espera={selectedMarker.espera}
            personas={selectedMarker.personas}
            title={selectedMarker.edificio.toUpperCase()}
            id={selectedMarker.id}
            estado={selectedMarker.estado}
          />
        )}
        <Legend />
        <MapTypeSelector />

        <div className="logo">
          <img src={logo} alt="Logo" className="logo" />
        </div>
      </div>
    </APIProvider>
  );
};
